// Registry for the `screen:<id>` figures in docs/concepts/portfolio.md.
// pages/ConceptPage.js resolves `![caption](screen:deal-model)` to the
// component here and renders it inside the same <figure>.
import PortfolioFleet from './PortfolioFleet';
import DealModel from './DealModel';
import Rollout from './Rollout';

export const PORTFOLIO_SCREENS = {
  'portfolio-fleet': PortfolioFleet,
  'deal-model': DealModel,
  rollout: Rollout,
};
